import { createSlice } from "@reduxjs/toolkit";
import { InitialState } from "../interfaces/pricing.interfaces";

const initialState: InitialState = {
  isLoading: false,
  data: {
    states: ["IN"],
    regions: [],
    hospitals: [],
    hospitalsSystems: [],
  },
};

const savePurchaseSelection = createSlice({
  name: "Save the purchase selection from the user",
  initialState,
  reducers: {
    savePurchaseSelectionData(state, action) {
      state.data = action.payload;
    },
    resetSelection(state) {
      state.data = initialState.data;
    },
  },
});

export const { savePurchaseSelectionData, resetSelection } = savePurchaseSelection.actions;
export default savePurchaseSelection.reducer;
